<template>
  <transition
    name="demo-success"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <div
      v-if="showModal"
      class="demo-submission-success modal-full bc-black-op z-100"
      role="dialog"
      aria-labelledby="demo-success-title"
      aria-modal="true"
    >
      <div class="demo-submission-success__backdrop" @click="close" />
      <div class="demo-submission-success__card bc-brand p-lg d-f fd-c ai-c tt-up w-60 g">
        <h4 id="demo-success-title" class="m-0">Success!</h4>
        <div class="d-f jc-sa ai-c w-100">
          <div class="d-f fd-c ai-c flex-1 demo-submission-success__block">
            <ImageWithInitials
              :src="senderImage"
              :name="senderName"
              :size="48"
              class="demo-submission-success__avatar"
            />
            <div class="mute">Demo:</div>
            <div>{{ data.title }}</div>
          </div>
          <div class="h-desktop-xl b-right"></div>
          <div class="d-f fd-c ai-c flex-1 demo-submission-success__block">
            <ImageWithInitials
              :src="receiverImage"
              :name="receiverName"
              :size="48"
              class="demo-submission-success__avatar"
            />
            <div class="mute">Sent to:</div>
            <div>{{ data.labelName }}</div>
          </div>
        </div>
        <h4 class="m-0">{{ countdown }}</h4>
      </div>
      <!-- <div
        type="button"
        class="demo-submission-success__close p-a t-0 r-0 m-lg d-f ai-c jc-c pointer x-btn animated"
        aria-label="Close"
        @click="close"
      >
        <IconBase w="30" h="30" viewBox="0 0 15 15" icon-name="close">
          <IconCancel />
        </IconBase>
      </div> -->
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import IconBase from "@/assets/icons/IconBase.vue";
import IconCancel from "@/assets/icons/IconCancel.vue";
import ImageWithInitials from "@/components/misc/ImageWithInitials.vue";

const TEST_PLACEHOLDER = {
  title: "Test Demo",
  labelName: "Test Label",
  submittedBy: null,
  submittedTo: null,
};

export default {
  name: "DemoSubmissionSuccess",
  components: { IconBase, IconCancel, ImageWithInitials },
  props: {
    testing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countdown: null,
      countdownInterval: null,
      testClosed: false,
      deferShow: false,
    };
  },
  computed: {
    ...mapGetters([
      "getDemoSubmissionSuccess",
      "getProfileImageByUid",
      "getProfileNameByUid",
    ]),
    data() {
      const real = this.getDemoSubmissionSuccess;
      if (real) return real;
      if (this.testing && !this.testClosed) return TEST_PLACEHOLDER;
      return null;
    },
    showModal() {
      return this.data && this.deferShow;
    },
    senderImage() {
      return this.data?.submittedBy
        ? this.getProfileImageByUid(this.data.submittedBy)
        : null;
    },
    senderName() {
      return this.data?.submittedBy
        ? this.getProfileNameByUid(this.data.submittedBy)
        : this.data?.title || "";
    },
    receiverImage() {
      return this.data?.submittedTo
        ? this.getProfileImageByUid(this.data.submittedTo)
        : null;
    },
    receiverName() {
      return this.data?.submittedTo
        ? this.getProfileNameByUid(this.data.submittedTo)
        : this.data?.labelName || "";
    },
  },
  watch: {
    data: {
      handler(val) {
        if (val) {
          this.startCountdown();
          this.$nextTick(() => {
            this.deferShow = true;
          });
        } else {
          this.stopCountdown();
          this.deferShow = false;
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    startCountdown() {
      this.stopCountdown();
      this.countdown = 4;
      this.countdownInterval = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.close();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      this.countdown = null;
    },
    close() {
      this.stopCountdown();
      if (this.testing) {
        this.testClosed = true;
      } else {
        this.$store.commit("CLEAR_DEMO_SUBMISSION_SUCCESS");
      }
    },
    beforeEnter(el) {
      const backdrop = el.querySelector(".demo-submission-success__backdrop");
      if (backdrop) {
        backdrop.style.opacity = "0";
        backdrop.style.transition = "opacity 0.3s ease";
      }
    },
    enter(el, done) {
      const card = el.querySelector(".demo-submission-success__card");
      const backdrop = el.querySelector(".demo-submission-success__backdrop");
      if (backdrop) backdrop.style.opacity = "1";
      const finish = () => {
        if (card) {
          card.removeEventListener("animationend", onEnd);
          card.classList.remove("demo-success-card--enter");
        }
        clearTimeout(fallback);
        done();
      };
      const onEnd = (e) => {
        if (e.target === card && e.animationName === "demo-success-card-in")
          finish();
      };
      const fallback = setTimeout(finish, 450);
      requestAnimationFrame(() => {
        if (card) {
          card.classList.add("demo-success-card--enter");
          card.addEventListener("animationend", onEnd);
        } else {
          finish();
        }
      });
    },
    afterEnter(el) {
      const backdrop = el.querySelector(".demo-submission-success__backdrop");
      if (backdrop) backdrop.style.opacity = "";
    },
    beforeLeave(el) {
      const card = el.querySelector(".demo-submission-success__card");
      const backdrop = el.querySelector(".demo-submission-success__backdrop");
      if (backdrop) {
        backdrop.style.transition = "opacity 0.3s ease";
      }
      if (card) {
        card.style.transition =
          "transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.3s ease";
      }
    },
    leave(el, done) {
      const card = el.querySelector(".demo-submission-success__card");
      const backdrop = el.querySelector(".demo-submission-success__backdrop");
      el.offsetHeight;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (backdrop) backdrop.style.opacity = "0";
          if (card) {
            card.style.opacity = "0";
            card.style.transform = "translateY(24px)";
            const finish = () => {
              card.removeEventListener("transitionend", onEnd);
              clearTimeout(fallback);
              done();
            };
            const onEnd = (e) => {
              if (e.target === card && e.propertyName === "transform") finish();
            };
            card.addEventListener("transitionend", onEnd);
            const fallback = setTimeout(finish, 400);
          } else {
            done();
          }
        });
      });
    },
    afterLeave() {
      // no-op; element is removed
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";

.demo-submission-success {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.demo-submission-success > * {
  pointer-events: auto;
}

.demo-submission-success__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}

@keyframes demo-success-card-in {
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.demo-submission-success__block {
  gap: 0.25rem;
}

.demo-submission-success__avatar {
  flex-shrink: 0;
  margin-bottom: 0.25rem;
}

.demo-submission-success__card {
  position: relative;
  z-index: 1;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;

  &.demo-success-card--enter {
    animation: demo-success-card-in 0.35s
      cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  }
}

.demo-submission-success__close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  background: transparent;
  border: none;
  cursor: pointer;
  color: inherit;
}


</style>
